import { React, useState, useEffect } from "react";
import {
    Modal
} from "@mui/material";
import PlantillaScreen from "../../helpers/PlantillaScreen";

export const AyudaModal = ({ open, onClose, seccion }) => {
    const conceptosER = [
        {
            nombre: "Ventas Netas",
            descripcion: {
                V: "Mayor al 85% de la venta neta proyectada.",
                A: "Entre 65% y 85% de la venta neta proyectada.",
                R: "Menor al 65% de la venta neta proyectada."
            }
        },
        {
            nombre: "Costo de Venta",
            descripcion: {
                V: "Menor o igual al costo proyectado.",
                A: "Entre el costo proyectado +1%.",
                R: "Mayor al costo proyectado +1%."
            }
        },
        {
            nombre: "Utilidad Bruta",
            descripcion: {
                V: "Mayor o igual a la utilidad bruta proyectada.",
                A: "Entre la utilidad bruta proyectada -1%.",
                R: "Menor a la utilidad bruta proyectada -1%."
            }
        },
        {
            nombre: "Gastos",
            descripcion: {
                V: "Menor al gasto proyectado.",
                A: "",
                R: "Mayor al gasto proyectado."
            }
        },
        {
            nombre: "Utilidad de Operación",
            descripcion: {
                V: "Mayor o igual a la utilidad de operación proyectada.",
                A: "Entre la utilidad de operación proyectada -1%.",
                R: "Menor a la utilidad de operación proyectada -1%."
            }
        }
    ];

    const conceptosEbitda = [
        {
            nombre: "Ventas Netas",
            descripcion: {
                V: "Mayor al 85% de la venta neta proyectada.",
                A: "Entre 65% y 85% de la venta neta proyectada.",
                R: "Menor al 65% de la venta neta proyectada."
            }
        },
        {
            nombre: "Costo de Venta",
            descripcion: {
                V: "Menor o igual al costo proyectado.",
                A: "Entre el costo proyectado +1%.",
                R: "Mayor al costo proyectado +1%."
            }
        },
        {
            nombre: "Utilidad Bruta",
            descripcion: {
                V: "Mayor o igual a la utilidad bruta proyectada.",
                A: "Entre la utilidad bruta proyectada -1%.",
                R: "Menor a la utilidad bruta proyectada -1%."
            }
        },
        {
            nombre: "Gastos",
            descripcion: {
                V: "Menor al gasto proyectado.",
                A: "",
                R: "Mayor al gasto proyectado."
            }
        },
        {
            nombre: "Utilidad de Operación",
            descripcion: {
                V: "Mayor o igual a la utilidad de operación proyectada.",
                A: "Entre la utilidad de operación proyectada -1%.",
                R: "Menor a la utilidad de operación proyectada -1%."
            }
        },
        {
            nombre: "Depreciación",
            descripcion: {
                V: "Menor a la depreciación proyectada.",
                A: "",
                R: "Mayor a la depreciación proyectada."
            }
        },
        {
            nombre: "EBITDA",
            descripcion: {
                V: "Mayor o igual al EBITDA proyectado.",
                A: "Entre EL EBITDA proyectado -1%.",
                R: "Menor a al EBITDA proyectado -1%."
            }
        }
    ];

    const conceptosERProyectado = [
        {
            nombre: "Ventas Netas",
            descripcion: {
                V: "Mayor al 85% de la venta neta.",
                A: "Entre 65% y 85% de la venta neta.",
                R: "Menor al 65% de la venta neta."
            }
        },
        {
            nombre: "Costo de Venta",
            descripcion: {
                V: "Menor o igual al costo.",
                A: "Entre el costo +1%.",
                R: "Mayor al costo +1%."
            }
        },
        {
            nombre: "Utilidad Bruta",
            descripcion: {
                V: "Mayor o igual a la utilidad bruta.",
                A: "Entre la utilidad bruta -1%.",
                R: "Menor a la utilidad bruta -1%."
            }
        },
        {
            nombre: "Gastos",
            descripcion: {
                V: "Menor al gasto proyectado.",
                A: "",
                R: "Mayor al gasto proyectado."
            }
        },
        {
            nombre: "Utilidad de Operación",
            descripcion: {
                V: "Mayor o igual a la utilidad de operación.",
                A: "Entre la utilidad de operación -1%.",
                R: "Menor a la utilidad de operación -1%."
            }
        }
    ];


    const conceptos =
        seccion === "estado_resultados"
            ? conceptosER
            : seccion === "ebitda"
                ? conceptosEbitda
                : seccion === "estado_resultados_proyeccion"
                    ? conceptosERProyectado
                    : [];
    return (
        <>
            <Modal open={open} onClose={onClose}>
                <div className="ayuda-modal-finanzas">
                    <div className="ayuda-modal-finanzas-plantilla">
                        <div
                            className="plantilla-screen-filtro-container"
                            id="mdlFiltros-modal"
                        >
                            <PlantillaScreen
                                titulo={"CRITERIOS DE SEMAFORO"}
                                className_main={1}
                                className={"plantilla-screen-filtro-container-modal"}
                            >
                                <div className="cerrar-modal-button" onClick={onClose}>
                                    X
                                </div>
                                <div className="ayuda-grid">

                                    <div></div> {/* espacio para columna de conceptos */}
                                    <div className="circulo rojo"></div>
                                    <div className="circulo amarillo"></div>
                                    <div className="circulo verde"></div>

                                    {/* Filas */}
                                    {conceptos.map((item, index) => (
                                        <>

                                            {/* Concepto */}
                                            <div className="col-concepto">
                                                {item.nombre}
                                            </div>

                                            {/* 🔴 */}
                                            <div className="col-desc rojo">
                                                {item.descripcion.R}
                                            </div>

                                            {/* 🟡 */}
                                            <div className="col-desc amarillo">
                                                {item.descripcion.A}
                                            </div>

                                            {/* 🟢 */}
                                            <div className="col-desc verde">
                                                {item.descripcion.V}
                                            </div>

                                        </>
                                    ))}

                                </div>
                            </PlantillaScreen>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};
